import { ReactNode, Ref, forwardRef } from 'react';

import { useTheme } from '@mui/joy';
import { StackProps } from '@mui/joy/Stack';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import InfoIcon from '@assets/EmptyInfo.svg?react';

interface InfoMessageProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string | ReactNode;
  sx?: StackProps['sx'];
  error?: boolean;
  button?: ReactNode;
}

const InfoMessage = forwardRef(
  (
    { error, button, icon, title, subtitle, sx }: InfoMessageProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const theme = useTheme();

    const defaultIcon = (
      <InfoIcon
        style={{
          fill: error
            ? theme.palette.danger[500]
            : theme.palette.isDarkMode
              ? theme.palette.primary[700]
              : theme.palette.primary[500],
        }}
      />
    );

    return (
      <Stack
        ref={ref}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          py: 2,
          gap: 1,
          ...sx,
        }}
      >
        {icon ?? defaultIcon}
        <Typography level='title-md' textColor='neutral.700' fontWeight={600}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            component='div'
            level='body-sm'
            textColor='neutral.700'
            sx={{ maxWidth: '450px' }}
          >
            {subtitle}
          </Typography>
        ) : null}
        {button}
      </Stack>
    );
  },
);

export default InfoMessage;
